import { Mediator } from 'application/src/js/util';
import {
  setHint
} from 'website/src/js/registration/shared/functions.js';

const mediator = new Mediator();

window.verifyCaptcha = token => mediator.publish('captchaVerify', token);

export default class Captcha {
  constructor(args) {
    this.translations = translations.registrationForm;

    this.container = document.querySelector('.grid-x.captcha');
    this.hintOut = this.container.querySelector('.hint');

    this.setHint = setHint.bind(this);

    this.errorClass = 'invalid';
    this.recaptchaResponse = '';

    this.addEvents();
  }

  addEvents() {
    mediator.subscribe('captchaVerify', token => {
      this.recaptchaResponse = token;
      this.setHint();
    });
  }

  validate() {
    const hints = [];
    let isValid = true;

    if (!this.recaptchaResponse) {
      hints.push({
        type: 'alert',
        text: this.translations.captchaError
      });
      isValid = false;
    }

    this.setHint(hints);

    return isValid;
  }
}